import Store from 'redux/store';
import { cloudloyalty } from '../clients';

import { FETCH_ORDERS, FETCH_ORDERS_SUCCESS, FETCH_ORDERS_FAIL } from 'redux/Reducers/Orders/OrdersList';

export const FetchOrdersList = async (User, finallyCallback = () => {}, { offset, limit }) => {
    Store.dispatch({ type: FETCH_ORDERS });
    cloudloyalty(User).get(`/v1/purchases/me/orders?orderId=&offset=${offset}&limit=${limit}`).then(({data: {orders, limit, offset, total }}) => {
      Store.dispatch({
        type: FETCH_ORDERS_SUCCESS,
        payload: {
          orders,
          limit,
          offset,
          total,
        },
      });
    }).catch((e) => {
      Store.dispatch({
        type: FETCH_ORDERS_FAIL,
        payload: {
            error: e
        }
      });
    })
      .finally(() => {
        finallyCallback();
      });
};
